import { colors } from "config/styles/themeColors";
import { fontSize } from "config/styles/fonts";

const styles = {
  checkbox: {
    mb: "-10px",
    p: {
      xs: "0 16px",
      md: "0 36px",
    },
  },
  inputsWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    p: {
      xs: "0 16px",
      md: "0 36px",
    },
  },
  dstWrap: (isDraggable: boolean) => ({
    display: "flex",
    alignItems: "center",
    gap: "20px",
    width: "100%",
    cursor: isDraggable ? "grab" : "unset",
    position: "relative",
  }),
  addressWrap: (isDraggable: boolean) => ({
    width: "100%",
    position: "relative",
    "& .MuiFormLabel-root.MuiInputLabel-root": {
      pl: isDraggable ? "14px" : 0,
    },
    "& .MuiAutocomplete-root.Mui-focused": {
      "& .MuiFormLabel-root.MuiInputLabel-root": {
        pl: 0,
      },
      "& .MuiFormLabel-root.MuiInputLabel-root.MuiFormLabel-filled": {
        transform: "translate(14px, -9px) scale(0.75)",
      },
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.MuiFormLabel-filled": {
      transform: "translate(2px, -9px) scale(0.75)",
    },
  }),
  addressInput: {
    flexBasis: "63%",
  },
  buildingInput: {
    flexBasis: "37%",
  },
  progress: (length: number) => ({
    position: "absolute",
    color: "text.secondary",
    right: length === 1 ? "10px" : "46px",
    top: "7px",
  }),
  addBtn: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "fit-content",
    fontSize: fontSize.xs,
    fontWeight: "bold",
    color: "green.main",
    ml: "auto",
    mt: "-10px",
    "& svg": {
      width: "18px",
      height: "18px",
    },
  },
  icon: {
    fill: colors.gray.disabled,
    position: "absolute",
    height: "18px",
    left: 0,
    zIndex: 1,
  },
};

export default styles;
